export const LOGO_HOME = 'logo-planalto.png'
export const BRAND_NAME = 'Planalto'
export const ADRESS =
	'Estrada Km 323 | BR-158 - Cerrito Santa Maria - RS CEP: 97.095-080'
export const COMPANY_NAME =
	'PLANALTO TRANSPORTES LTDA. - CNPJ: 95.592.077/0010-03'
export const EMAIL = 'sac@planalto.com.br'
export const RATING_SITE_URL =
	'https://www.reclameaqui.com.br/empresa/planalto-transporte'
export const CHIPEST =
	'Viaje com qualidade pagando menos! A Planalto oferece tarifas acessíveis e ótimo custo-benefício. Conheça novos destinos com conforto e economia.'
export const IS_DIGITAL =
	'Compre sua passagem pelo site e embarque direto com o celular. Praticidade e agilidade em cada etapa da sua viagem com a Planalto.'
export const RELIBLE =
	'Com mais de 75 anos de estrada, a Planalto é referência em segurança e tradição. Uma empresa sólida e reconhecida por sua excelência.'
export const TRAVEL =
	'Acumule pontos Muviflex em suas viagens com a Planalto. Troque por descontos, passagens grátis e vantagens exclusivas.'
export const EASY_PURCHASE =
	'Pague com Cartão, Pix, Muvicard ou Pontos. Conte sempre com um atendimento ágil e atencioso em todos os canais da Planalto.'
export const LOGO_LOADING = 'loading-logo-planalto.png'
export const URL_HOME = 'planalto.com.br'
export const TOKEN_HANDTALK = '23aa7c0f87eeb2909ac256b6445bb8c1'
export const META_PIXEL = '1643560339652120'
export const TIKTOK_PIXEL = 'D10A55JC77UCOE1UBIAG'
export const PLATFORM = 1
export const AGENCY = 2
export const APP_ID = 10004
export const APP_DESCRIPTION = 'WEB PLANALTO'
export const FACEBOOK_LINK = 'https://www.facebook.com/TransportesPlanalto'
export const INSTAGRAM_LINK = 'https://www.instagram.com/planalto.transportes/'
export const APP_ANDROID_LINK =
	'https://play.google.com/store/apps/details?id=com.planalto.app'
export const APP_IOS_LINK =
	'https://apps.apple.com/br/app/planalto/id6753179177'
export const BANNER_APP_DESKTOP = 'planalto/planalto-banner-app-desktop.png'
export const BANNER_APP_MOBILE = 'planalto/planalto-banner-app-mobile.png'
// Item "Institucional" do menu: URL externa (abre fora da SPA)
export const INSTITUTIONAL_URL = 'https://institucional.planalto.com.br'
